import microuniversoApi from "app/api/microuniversoApi";
import store from "../../redux/store/store";
import { sobrescreverInformacoesAction } from "../../redux/orcamentoSlice";
declare var window: any

export async function liberarPendenciaOrcamento(
    identificadorOrcamento: string,
    motivoLiberacaoPendencia?: string,
    senhaLiberacaoPendencia?: string
) {
    const partial = await microuniversoApi.Orcamento.liberarPendencias(
        identificadorOrcamento,
        motivoLiberacaoPendencia,
        senhaLiberacaoPendencia
    )

    const atualizarOrcamentoLegadoERedux = () => {
        const orcamentoLegado = window.orcamentoController.model
        const orcamentoReact = store.getState().orcamento
        const novoOrcamento = {
            ...orcamentoReact,
            DataMarcadaEntrega: partial.DataMarcadaEntrega,
            DataPrevisaoEntrega: partial.DataPrevisaoEntrega,
            Inconsistencias: partial.Inconsistencias,
            MotivoLiberacaoPendencia: partial.MotivoLiberacaoPendencia,
            ObrigatorioInformarMotivoLiberacaoPendencias: partial.ObrigatorioInformarMotivoLiberacaoPendencias,
            PossuiErros: partial.PossuiErros,
            PossuiPendencias: partial.PossuiPendencias,
            PossuiPerguntas: partial.PossuiPerguntas,
            SenhaLiberacaoPendencia: partial.SenhaLiberacaoPendencia,
            SequencialAlteracao: partial.SequencialAlteracao,

        }
        orcamentoLegado.atualizar(novoOrcamento)

        store.dispatch(sobrescreverInformacoesAction(novoOrcamento))
    }


    atualizarOrcamentoLegadoERedux()

    return partial;
}
